import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Authenticator, 
  ThemeProvider, 
  useTheme,
  View,
  Image,
  Heading,
  useAuthenticator
} from '@aws-amplify/ui-react';
import { Box, Container, Paper } from '@mui/material';
import '@aws-amplify/ui-react/styles.css';

const components = {
  Header() {
    const { tokens } = useTheme();
    
    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Heading level={3}>247ops.ai</Heading>
      </View>
    );
  },
  
  Footer() {
    const { tokens } = useTheme();
    
    return (
      <View textAlign="center" padding={tokens.space.medium}>
        <p>&copy; {new Date().getFullYear()} 247ops.ai. All Rights Reserved.</p>
      </View>
    );
  }
};

// Custom theme for Amplify UI
const theme = {
  name: 'custom-theme',
  tokens: {
    colors: {
      brand: {
        primary: {
          10: { value: '#f0f8ff' },
          20: { value: '#d1e9ff' },
          40: { value: '#a3d2ff' },
          60: { value: '#75bcff' },
          80: { value: '#47a6ff' },
          90: { value: '#1890ff' }, // Primary color
          100: { value: '#0076e4' },
          120: { value: '#0062bd' },
          140: { value: '#004d96' },
          160: { value: '#00396f' },
        },
      },
    },
    components: {
      authenticator: {
        // Properly structured for Amplify UI v6
        modal: {
          width: { value: '30rem' },
          borderRadius: { value: '8px' },
        },
      },
    },
  },
};

export function AuthStatus() {
  const { route } = useAuthenticator(context => [context.route]);
  const navigate = useNavigate();
  
  useEffect(() => {
    if (route === 'authenticated') {
      navigate('/');
    }
  }, [route, navigate]);
  
  return null;
}

export default function Login() {
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <Box sx={{ p: 2 }}>
          <ThemeProvider theme={theme}>
            <Authenticator components={components}>
              <AuthStatus />
            </Authenticator>
          </ThemeProvider>
        </Box>
      </Paper>
    </Container>
  );
}
